'use strict';

exports.__esModule = true;

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _webUtils = require('@vezeeta/web-utils');

var _Splash = require('@vezeeta/web-components/lib/splash/Splash');

var _Splash2 = _interopRequireDefault(_Splash);

var _Authenticate = require('./Authenticate');

var _Authenticate2 = _interopRequireDefault(_Authenticate);

var _SignOut = require('./SignOut');

var _SignOut2 = _interopRequireDefault(_SignOut);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// $FlowFixMe
var logoUrl = process.env.REACT_APP_CDN_URL + '/assets/logo-blue.png';

var AuthContainer = (_temp2 = _class = function (_Component) {
  _inherits(AuthContainer, _Component);

  function AuthContainer() {
    var _temp, _this, _ret;

    _classCallCheck(this, AuthContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      isLoading: true
    }, _this.renderChildren = function () {
      var onAuthenticate = _this.props.onAuthenticate;

      onAuthenticate();
      _this.setState({
        isLoading: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  AuthContainer.prototype.componentDidMount = function componentDidMount() {
    var isAuthenticated = _webUtils.Cookie.get(_webUtils.Cookie.AUTH_TOKEN);

    if (isAuthenticated) {
      if (!sessionStorage.getItem('session')) {
        (0, _Authenticate2.default)(this.renderChildren);
      } else {
        this.renderChildren();
      }
    } else {
      (0, _SignOut2.default)();
    }
  };

  AuthContainer.prototype.render = function render() {
    var children = this.props.children;
    var isLoading = this.state.isLoading;


    if (isLoading) {
      return _react2.default.createElement(_Splash2.default, { logoUrl: logoUrl });
    }

    return children;
  };

  return AuthContainer;
}(_react.Component), _class.defaultProps = {
  onAuthenticate: function onAuthenticate() {}
}, _temp2);
exports.default = AuthContainer;
module.exports = exports['default'];